

import "./objects.scss"

import kraty from "./assets/buildings/kraty.png";
import stacja_zlewna from "./assets/buildings/stacja_zlewna.png";
import pompownia_glowna from "./assets/buildings/pompownia_glowna.png";
import koryto_pomiarowe from "./assets/buildings/korpom.gif";
import piaskownik from "./assets/buildings/piaskownik.png";
import pianime from "./assets/buildings/piaskownik_anime.png";
import osadniki from "./assets/buildings/wstepne_osadniki.png";
import osadniki2 from "./assets/buildings/wtorne_osadniki.png";
import os from "./assets/buildings/osadniki.png"
import komora_beztlenowa from "./assets/buildings/komora_beztlenowa.png";
import komora_osadu_czynnego from "./assets/buildings/komora_osadu.png";
import koryto_wylotowe from "./assets/buildings/korytowylot.gif";
import stacja_pix from "./assets/buildings/stacja_pix.png";
import wkf2 from "./assets/buildings/wkf2.png";
import prasa_tasmowa from "./assets/buildings/prasa_tasmowa.png";
import zageszczacz_grawitacyjny from "./assets/buildings/zageszczacz_grawitacyjny.png";
import biogaz from "./assets/buildings/biogaz.png";
import odsiarczalnik from "./assets/buildings/odsiarczalnik.png";
import OdsiarczalnikShape from "./assets/buildings/shapes/odsiarczalnik_shape.svg";
import kotly from "./assets/buildings/kotly.png";
import biokonwersja_odpadu from "./assets/buildings/biokonwersja_odpadu.png";
import biostruktury from "./assets/buildings/biostruktury.png";
import pochodnia from "./assets/buildings/pochodnia.png";

import kotly1 from "./assets/buildings/kotly1.png";
import kotly2 from "./assets/buildings/kotly2.png";

// kraty 
import kraty1 from "./assets/images/Kraty/1.jpg"
import kraty2 from "./assets/images/Kraty/2.jpg"
import kraty3 from "./assets/images/Kraty/3.jpg"
import kraty4 from "./assets/images/Kraty/4.jpg"
//Stacja
import stacja1 from "./assets/images/Stacja_Zlewna/1.jpg"
import stacja2 from "./assets/images/Stacja_Zlewna/2.jpg"
import stacja3 from "./assets/images/Stacja_Zlewna/3.jpg"
import stacja4 from "./assets/images/Stacja_Zlewna/4.jpg"
import stacja5 from "./assets/images/Stacja_Zlewna/5.jpg"
//Pompownia
import pompo1 from "./assets/images/Pompownia_Glowna/1.jpg"
import pompo2 from "./assets/images/Pompownia_Glowna/2.jpg"
import pompo3 from "./assets/images/Pompownia_Glowna/3.jpg"
import pompo4 from "./assets/images/Pompownia_Glowna/4.jpg"
//Koryto
import korPo1 from "./assets/images/Koryto_Pomiarowe/1.jpg"
import korPo2 from "./assets/images/Koryto_Pomiarowe/2.jpg"
import korPo3 from "./assets/images/Koryto_Pomiarowe/3.jpg"
import korPo4 from "./assets/images/Koryto_Pomiarowe/4.jpg"
//Piaskownik
import piasko1 from "./assets/images/Piaskownik/1.jpg"
import piasko2 from "./assets/images/Piaskownik/2.jpg"
import piasko3 from "./assets/images/Piaskownik/3.jpg"
//Osadniki wstepne
import osws1 from "./assets/images/Osadniki_wstepne/1.jpg"
import osws2 from "./assets/images/Osadniki_wstepne/2.jpg"
import osws3 from "./assets/images/Osadniki_wstepne/3.jpg"
import osws4 from "./assets/images/Osadniki_wstepne/4.jpg"
//Komora
import komora1 from "./assets/images/Komora_beztlenowa/1.jpg"
import komora2 from "./assets/images/Komora_beztlenowa/2.jpg"
import komora3 from "./assets/images/Komora_beztlenowa/3.jpg"
//Komora osadu czynnego
import osad1 from "./assets/images/Komora_osadu/1.jpg"
import osad2 from "./assets/images/Komora_osadu/2.jpg"
import osad3 from "./assets/images/Komora_osadu/3.jpg"
import osad4 from "./assets/images/Komora_osadu/4.jpg"
//Osadniki wtorne
import oswt1 from "./assets/images/Osadniki_wtorne/1.jpg"
import oswt2 from "./assets/images/Osadniki_wtorne/2.jpg"
import oswt3 from "./assets/images/Osadniki_wtorne/3.jpg"
import oswt4 from "./assets/images/Osadniki_wtorne/4.jpg"
//Koryto_wylotowe
import korWy1 from "./assets/images/Koryto_wylotowe/1.jpg"
import korWy2 from "./assets/images/Koryto_wylotowe/2.jpg"
import korWy3 from "./assets/images/Koryto_wylotowe/3.jpg"
//Stacja pix
import pix1 from "./assets/images/Stacja_pix/1.jpg"
import pix2 from "./assets/images/Stacja_pix/2.jpg"
import pix3 from "./assets/images/Stacja_pix/3.jpg"
import pix4 from "./assets/images/Stacja_pix/4.jpg"
//Wkfz
import wkfz1 from "./assets/images/Wkfz/1.jpg"
import wkfz2 from "./assets/images/Wkfz/2.jpg"
import wkfz3 from "./assets/images/Wkfz/3.jpg"
import wkfz4 from "./assets/images/Wkfz/4.jpg"
//prasa_tasmowa
import prasa1 from "./assets/images/Prasa_tasmowa/1.jpg"
import prasa2 from "./assets/images/Prasa_tasmowa/2.jpg"
import prasa3 from "./assets/images/Prasa_tasmowa/3.jpg"
import prasa4 from "./assets/images/Prasa_tasmowa/4.jpg"
import prasa5 from "./assets/images/Prasa_tasmowa/5.jpg"
import prasa6 from "./assets/images/Prasa_tasmowa/6.jpg"
//zageszczacz
import zag1 from "./assets/images/Zageszczacz/1.jpg"
import zag2 from "./assets/images/Zageszczacz/2.jpg"
import zag3 from "./assets/images/Zageszczacz/3.jpg"
import zag4 from "./assets/images/Zageszczacz/4.jpg"
import zag5 from "./assets/images/Zageszczacz/5.jpg"
//biogaz
import bio1 from "./assets/images/Biogaz/1.jpg"
import bio2 from "./assets/images/Biogaz/2.jpg"
import bio3 from "./assets/images/Biogaz/3.jpg"
import bio4 from "./assets/images/Biogaz/4.jpg"
import bio5 from "./assets/images/Biogaz/5.jpg"
//odsiarczalnik
import od1 from "./assets/images/Odsiarczalnik/1.jpg"
import od2 from "./assets/images/Odsiarczalnik/2.jpg"
import od3 from "./assets/images/Odsiarczalnik/3.jpg"
import od4 from "./assets/images/Odsiarczalnik/4.jpg"
import od5 from "./assets/images/Odsiarczalnik/5.jpg"
//kogenerator
import kog1 from "./assets/images/Kogenerator/1.jpg"
import kog2 from "./assets/images/Kogenerator/2.jpg"
import kog3 from "./assets/images/Kogenerator/3.jpg"
import kog4 from "./assets/images/Kogenerator/4.jpg"
import kog5 from "./assets/images/Kogenerator/5.jpg"
import kog6 from "./assets/images/Kogenerator/6.jpg"
//kotly
import kot1 from "./assets/images/Kotly/1.jpg"
import kot2 from "./assets/images/Kotly/2.jpg"
import kot3 from "./assets/images/Kotly/3.jpg"
import kot4 from "./assets/images/Kotly/4.jpg"
import kot5 from "./assets/images/Kotly/5.jpg"
import kot6 from "./assets/images/Kotly/6.jpg"
//biokonwersja
import biokon1 from "./assets/images/Biokonwersacja/1.jpg"
import biokon2 from "./assets/images/Biokonwersacja/2.jpg"
import biokon3 from "./assets/images/Biokonwersacja/3.jpg"
import biokon4 from "./assets/images/Biokonwersacja/4.jpg"
//biostruktury
import bios1 from "./assets/images/Biostruktury/1.jpg"
import bios2 from "./assets/images/Biostruktury/2.jpg"
import bios3 from "./assets/images/Biostruktury/3.jpg"
import bios4 from "./assets/images/Biostruktury/4.jpg"
import bios5 from "./assets/images/Biostruktury/5.jpg"
import bios6 from "./assets/images/Biostruktury/6.jpg"
import bios7 from "./assets/images/Biostruktury/7.jpg"
//pochodnia
import pocho1 from "./assets/images/Pochodnia/1.jpg"
import pocho2 from "./assets/images/Pochodnia/2.jpg"
import pocho3 from "./assets/images/Pochodnia/3.jpg"


import ooo from "./assets/ooo.gif"
import ooo2 from "./assets/ooo2.gif"
import ooo3 from "./assets/ooo3.gif"
import ooo4 from "./assets/ooo4.gif"
import ooo5 from "./assets/ooo5.gif"

import flames from "./assets/flames.gif"
import wodaosad from "./assets/wodaosad.gif"


//video 
import krVideo from "./assets/videos/1.mp4";
import stVideo from "./assets/videos/2.mp4";
import poVideo from "./assets/videos/3.mp4";
import korVideo from "./assets/videos/4.mp4";
import piaVideo from "./assets/videos/5.mp4";
import oswsVideo from "./assets/videos/6.mp4";
import komVideo from "./assets/videos/7.mp4";

import osVideo1 from "./assets/videos/8.mp4";
import osVideo2 from "./assets/videos/8b.mp4";
import osVideo3 from "./assets/videos/8c.mp4";

import oswtVideo from "./assets/videos/9.mp4";
import korwyVideo from "./assets/videos/10.mp4";
import pixVideo from "./assets/videos/11.mp4";
import wkfzVideo from "./assets/videos/12.mp4";
import prasVideo from "./assets/videos/13.mp4";
import zagVideo from "./assets/videos/14.mp4";
import gazVideo from "./assets/videos/15.mp4";
import odsVideo from "./assets/videos/16.mp4";
import kogVideo from "./assets/videos/17.mp4";
import kotlyVideo from "./assets/videos/18.mp4";
import osadVideo from "./assets/videos/19.mp4";
import biostrVideo from "./assets/videos/20.mp4";
import pochoVideo from "./assets/videos/21.mp4";



//audio
import kraud from "./assets/sounds/01.mp3"
import krauden from "./assets/sounds/01en.mp3"
import staud from "./assets/sounds/02.mp3"
import stauden from "./assets/sounds/02en.mp3"
import poaud from "./assets/sounds/03.mp3"
import poauden from "./assets/sounds/03en.mp3"
import koaud from "./assets/sounds/04.mp3"
import koauden from "./assets/sounds/04en.mp3"
import piaud from "./assets/sounds/05.mp3"
import piauden from "./assets/sounds/05en.mp3"
import oswsaud from "./assets/sounds/06.mp3"
import oswsauden from "./assets/sounds/06en.mp3"
import komaud from "./assets/sounds/07.mp3"
import komauden from "./assets/sounds/07en.mp3"
import osadaud from "./assets/sounds/08.mp3"
import osadauden from "./assets/sounds/08en.mp3"
import oswtaud from "./assets/sounds/09.mp3"
import oswtauden from "./assets/sounds/09en.mp3"
import korsaud from "./assets/sounds/10.mp3"
import korsauden from "./assets/sounds/10en.mp3"
import pixaud from "./assets/sounds/11.mp3"
import pixauden from "./assets/sounds/11en.mp3"
import wkfzaud from "./assets/sounds/12.mp3"
import wkfzauden from "./assets/sounds/12en.mp3"
import prasaud from "./assets/sounds/13.mp3"
import prasauden from "./assets/sounds/13en.mp3"
import zagaud from "./assets/sounds/14.mp3"
import zagauden from "./assets/sounds/14en.mp3"
import bioaud from "./assets/sounds/15.mp3"
import bioauden from "./assets/sounds/15en.mp3"
import odsaud from "./assets/sounds/16.mp3"
import odsauden from "./assets/sounds/16en.mp3"
import kogaud from "./assets/sounds/17.mp3"
import kogauden from "./assets/sounds/17en.mp3"
import kotaud from "./assets/sounds/18.mp3"
import kotauden from "./assets/sounds/18en.mp3"
import biokonaud from "./assets/sounds/19.mp3"
import biokonauden from "./assets/sounds/19en.mp3"
import biostraud from "./assets/sounds/20.mp3"
import biostrauden from "./assets/sounds/20en.mp3"
import pochoaud from "./assets/sounds/21.mp3"
import pochoauden from "./assets/sounds/21en.mp3"

const objects = [
  {
    id: 1,
    class: "kraty",
    title: "KRATY",
    titleEn: "GRILLES",
    model: kraty, 
    model_shape: <svg id="Warstwa_1" className="W1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 163.92 168.42"><defs></defs><polygon className="cls-1"
     points="0.58 53.36 0.58 58.25 2.58 59.25 3.03 122.47 96 168.42 160.42 116.17 160.42 56.25 163.92 53.92 163.92 50.25 68.83 0 0 53.21 0.58 53.36"/></svg>,
    description: "Pierwszym etapem oczyszczania mechanicznego ścieków są kraty, które służą do usuwania dużych zanieczyszczeń takich jak szmaty, papier, czy kawałki drewna.",
    descriptionEn: "The first stage of mechanical sewage treatment are grilles, which are used to remove big contaminations, such as rags, paper, or pieces of wood.",
    images: [kraty1, kraty2, kraty3, kraty4],
    videos: [krVideo],
    audio: kraud,
    audioen: krauden,
    dur: 9462,
    osadop: "osadop"
  },
  {
    id: 2,
    class: "stacja_zlewna",
    title: "STACJA ZLEWNA",
    titleEn: "SEWAGE STORAGE STATION",
    model: stacja_zlewna, 
    model_shape: <svg id="Warstwa_1" className="W2" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 184.06 186.67"><defs></defs><path className="cls-1" d="M71,0,39.22,25.56H36.11L0,54v72.89l6.78,2.67,3.78-3,101.16,49.77v7.39l6,2.95L154,157.44v-1.77l30.06-23.95V59l-4.5-2.39-7.34,5.78-7.11-3.56L75.17,14c-.17-3.83-.34-7.67-.5-11.5Z"/></svg>,
    description: "Stacja zlewna to punkt przyjęcia ścieków dowożonych do oczyszczalni wozami asenizacyjnymi z tych obszarów Rybnika, które nie mają dostępu do sieci kanalizacyjnej.",
    descriptionEn: "Sewage storage station is the point of receiving sewage delivered to the sewage treatment plant via slurry tankers from those areas of Rybnik that do not have access to sewer network.",
    images: [stacja1, stacja2, stacja3, stacja4, stacja5],
    videos: [stVideo],
    audio: staud,
    audioen: stauden,
    dur: 10368,
      osadop: "osadop"
  },
  {
    id: 3,
    class: "pompownia_glowna",
    title: "POMPOWNIA GŁÓWNA",
    titleEn: "MAIN PUMPING STATION",
    model: pompownia_glowna, 
    model_shape: <svg id="Warstwa_1" className="W3" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 157.64 159.22"><defs></defs><path className="cls-1" d="M152.53,60.35a28.18,28.18,0,0,0,5.11-15.79C157.64,20,122.35,0,78.82,0S0,20,0,44.56A28,28,0,0,0,4.75,59.82v60.51h0c0,.28,0,.56,0,.84,0,21,33.08,38.05,73.89,38.05s73.89-17,73.89-38c0-.28,0-.56,0-.84h0Z"/></svg>,
    description: "Pompownia główna wyposażona jest w 5 pomp o wydajności od 600 do 1200 m<sup>3</sup>/h. Jej funkcja jest uzyskanie stałego, płynnego przepływu przez oczyszczalnię. Wpływa to korzystnie na funkcjonowanie mechanicznej i biologicznej części oczyszczalni.",
    descriptionEn: "The main pumping station is equipped with 5 pumps with efficiency ranging from 600 to 1200 m<sup>3</sup>/h. It's function is to achieve a constant and smooth flow through the sewage treatment plant. This has a positive impact on the functioning of mechanical and biological part of the sewage treatment plant.",
    images: [pompo1, pompo2, pompo3, pompo4],
    videos: [poVideo],
    audio: poaud,
    audioen: poauden,
    dur: 18102,
    osadop: "osadop"
  },
  {
    id: 4,
    class: "koryto_pomiarowe",
    title: "KORYTO POMIAROWE",
    titleEn: "MEASUREMENT TROUGH",
    model: koryto_pomiarowe, 
    model_shape: <svg id="Warstwa_1" className="W4" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.83 86.17"><defs></defs><polygon className="cls-1" points="0 22.83 0 40.33 92.33 86.17 121.83 63 121.83 46.17 28.83 0 0 22.83"/></svg>,
    description: "Za pompownią znajduje się koryto pomiarowe gdzie odbywa się pomiar ilości ścieków dopływających do oczyszczalni. Średni dobowy przepływ to 17 000 m<sup>3</sup>, a projektowana ilość ścieków jaką może przyjąć oczyszczalnia to 27 000 m<sup>3</sup>/dobę.",
    descriptionEn: "After the pumping station is located a measurement through, where the amount of sewage flowing into sewage treatment plant is measured. Average daily flow is 17,000 m<sup>3</sup> and the designed amount of sewage that the sewage treatment plant can receive is 27,000 m<sup>3</sup>/day.",
    images: [korPo1, korPo2, korPo3, korPo4],
    videos: [korVideo],
    audio: koaud,
    audioen: koauden,
    dur: 17922,
      osadop: "osadop"
  },
  {
    id: 5,
    class: "piaskownik",
    title: "PIASKOWNIK",
    titleEn: "SAND SEPARATOR",
    model: piaskownik, 
    model_shape: <svg id="Warstwa_1" className="W5" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 187.75 146.81"><defs></defs><path className="cls-1" d="M157.85,92.39s-.85-.71-3.91-.4l33.81-27.93V55.18l-14.83-7.92,4-3.29V29.72L175.71,29V20.39L135.5,0,122.06,10.61V22.33L98.72,10.78,0,89.47V105l1.83.92v20.5l2.92,1.67v12.16l9.92,5.34,6.83-10.09,20.58,10.09,14.84-12.25,29.41,13.3s2.17.95,5.61-1.33,17.34-13.78,17.34-13.78l40-32.17,4.34-3.48s3.32-1.34,4.09,2l1.14-.86s.69-3.91-.89-4.56"/></svg>,
    description: "Zadaniem piaskownika jest zatrzymywanie piasku, drobnych zanieczyszczeń i zawiesiny, a także separacja tłuszczów.",
    descriptionEn: "The purpose of the sand separator is stopping sand, fine contamination, and suspension, as well as separating fats.",
    images: [piasko1, piasko2, piasko3],
    videos: [piaVideo],
    audio: piaud,
    audioen: piauden,
    dur: 6834,
    piaskownikAnime: pianime,
    osadop: "osadop"
  },
  {
    id: 6,
    class: "osadniki_wstepne",
    title: "OSADNIKI WSTĘPNE",
    titleEn: "INITIAL SETTLING TANKS",
    model: osadniki, 
    model_kotly: os,
    model_shape: <svg id="Warstwa_1" className="W6" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 570 368.81"><defs></defs><ellipse className="cls-1 cls-ws" cx="118.92" cy="303.08" rx="116.81" ry="65.73"/><ellipse className="cls-1 cls-ws" cx="280.75" cy="185.92" rx="116.81" ry="65.73"/><ellipse className="cls-1 cls-ws" cx="451.42" cy="67.83" rx="116.81" ry="65.73"/></svg>,
    description: "Oczyszczalnia posiada 3 osadniki wstępne o łącznej pojemności 2510 m<sup>3</sup>. Ich zadaniem jest wytrącanie zawiesin łatwoopadających. Zawiesiny zgromadzone w leju osadowym nazywamy osadem wstępnym, który po zagęszczeniu trafia do komór fermentacyjnych.",
    descriptionEn: "The sewage treatment plant possesses 3 initial settling tanks with total capacity of 2,510 m<sup>3</sup>. Their purpose is to precipitate the easy falling suspensions. Suspensions collected in the sediment hopper are called the initial sediment, which after concentration is moved to fermentation chambers.",
    images: [osws1, osws2, osws3, osws4],
    videos: [oswsVideo],
    audio: oswsaud,
    audioen: oswsauden,
    dur: 19434,
    spinBr: [
      {
        spin: [ooo, ooo2, ooo3],
        classSpin: ["spws1", "spws2", "spws3"]
      }
    ] 
  },
  {
    id: 7,
    class: "komora_beztlenowa",
    title: "KOMORA BEZTLENOWA",
    titleEn: "ANAEROBIC CHAMBER",
    model: komora_beztlenowa, 
    model_shape: <svg id="Warstwa_1" className="W7" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 369.92 204.08"><defs></defs><path className="cls-1" d="M23.5,71.11v8.64L0,88.92V105L29.08,94.5l25.75,13.42-8.41,6.75V125L126,164l15-11.34,25.56,29.17,1-1.5.39-6.44,14.39-11.06,4,2.39,1.66-1.78-3.28-4.11V157l96.14,47.11,89.09-71V109.36L366.86,108V94.42L176.42,0,94.92,64.71V80l-3.23,1.68L49.47,60.31l-27,9.11,0,1.61Z"/></svg>,
    description: "W komorze beztlenowej mieszają się ścieki oczyszczone mechanicznie z osadem czynnym zawracanym z osadników wtórnych. W tym miejscu rozpoczyna się biologiczne oczyszczanie ścieków.",
    descriptionEn: "In the anaerobic chamber, the mechanically treated sewage is mixed with active sediment returned from secondary settling tanks. This place is the starting point of biological sewage treatment.",
    images: [komora1, komora2, komora3],
    videos: [komVideo],
    audio: komaud,
    audioen: komauden,
    dur: 11442
  },
  {
    id: 8,
    class: "komora_osadu_czynnego2",
    class2: "bio2",
    title: "KOMORA OSADU CZYNNEGO",
    titleEn: "ACTIVE SEDIMENT CHAMBER",
    model: komora_osadu_czynnego, 
    model_shape: <svg id="Warstwa_1" className="W8" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 725 490.01"><defs></defs><path className="cls-1" d="M725,185.24c0-39.12-56.59-70.84-126.39-70.84a221.45,221.45,0,0,0-31.84,2.27,5,5,0,0,0-10,.9,5.29,5.29,0,0,0,.08.8c-49.27,9.67-84.61,35.95-84.61,66.87v12.44h0c0,.52,0,1,0,1.56,0,13.17,6.15,25.53,16.89,36.17v36.21h.21a41.46,41.46,0,0,0,6.25,17.63c-21.8-10-49.68-16-80.07-16a221.45,221.45,0,0,0-31.84,2.27,5.06,5.06,0,0,0-5-4.16,4.73,4.73,0,0,0-.93.1V270l-3-2.15,5.68-4.46,2.77,1.11,3.25-2.59v-44l1.15-1.14-13.89-7.73c29.17-10.57,49.14-28.87,51.33-50h.21V122.89c10.74-10.64,16.89-23,16.89-36.17,0-.52,0-1,0-1.55h0V72.72c0-39.12-56.59-70.83-126.39-70.83a221.45,221.45,0,0,0-31.84,2.27,5,5,0,0,0-10,.9,5.42,5.42,0,0,0,.08.8c-49.27,9.67-84.61,36-84.61,66.86V85.17h0c0,.51,0,1,0,1.55,0,13.18,6.15,25.53,16.89,36.17V158.7c-21.76-9.95-49.55-15.92-79.83-15.92a221.45,221.45,0,0,0-31.84,2.27,5,5,0,0,0-10,.89,5.42,5.42,0,0,0,.08.81C35.34,156.41,0,182.7,0,213.61v12.45H0c0,.51,0,1,0,1.55,0,13.18,6.15,25.53,16.89,36.17V300h.21a42.38,42.38,0,0,0,7.81,20A37.55,37.55,0,0,0,22,329.78v10.75h0a5.33,5.33,0,1,0,10.66,0V329.78c0-.3,0-.58-.06-.87,19.18,18.37,54,30.66,93.76,30.66,58.22,0,105.83-26.33,109.29-59.57h.21V263.78c10.74-10.64,16.89-23,16.89-36.17,0-.52,0-1,0-1.55h0V213.61a40.27,40.27,0,0,0-.57-6.69A159.7,159.7,0,0,0,298,217.85l-48.36,33.26v47.83l46.31,22.16a43.72,43.72,0,0,0-6.81,23V356.5h0c0,.52,0,1,0,1.56,0,13.17,6.15,25.52,16.89,36.17v36.21h.21a42.34,42.34,0,0,0,7.81,20,37.79,37.79,0,0,0-2.88,9.79V471h0a5.34,5.34,0,1,0,10.67,0V460.22c0-.29-.05-.58-.07-.87,19.18,18.38,54,30.66,93.76,30.66,58.22,0,105.83-26.33,109.29-59.57H525V394.23c10.74-10.65,16.89-23,16.89-36.17,0-.52,0-1,0-1.56h0V344.06c0-8.9-2.94-17.41-8.28-25.26,18.18,7.79,40.66,12.39,65,12.39,58.23,0,105.83-26.33,109.29-59.57h.21V235.41c10.74-10.64,16.89-23,16.89-36.17,0-.52,0-1,0-1.56h0Z"/></svg>,
    description: "Oczyszczalnia eksploatuje cztery komory osadu czynnego. Każda z nich ma pojemność 4 000 m<sup>3</sup>. W komorach zaomstalowane są mieszadła śmigłowe oraz ruszty napowietrzające służące do mieszania i napowietrzania ścieków. Od tego miejsca mówimy o właściwym biologicznym oczyszczaniu ścieków przez mikroorganizmy osadu czynnego. Oczyszczanie biologiczne polega głównie na usuwaniu ścieków związków azotu i fosforu. Jeżeli chcesz zobaczyć jak wygląda osad czynny zajrzyj pod mikroskop<sup>*</sup>.",
    descriptionEn: "The sewage treatment plant uses four active sediment chambers. Each one of them has capacity of 4,000 m<sup>3</sup> In Chambers are installed agitators and aeration grates that are used to mix and aerate sewage respectively. From this point we speak about the proper biological sewage treatment done by microorganisms of active sediment. Biological treatment consists mostly of removing compounds of nitrogen and phosphorus from sewage. If you want to see how active sediment looks like, take a look in the microscope*.",
    microDesc: "<sup>*</sup> zdjęcia i filmy spod mikroskopu oznaczone są tą ikonką",
    microDescEn: "<sup>*</sup> photos and videos from the microscope are marked with this icon",
    micro_img: "imggg",
    images: [osad1, osad2, osad3, osad4],
    videos: [osVideo1, osVideo2, osVideo3],
    audio: osadaud,
    audioen: osadauden,
    dur: 32430,
    water: wodaosad,
  },
  {
    id: 9,
    class: "osadniki_wtorne",
    title: "OSADNIKI WTÓRNE",
    titleEn: "SECONDARY SETTLING TANKS",
    model: osadniki2, 
    model_kotly: os,
    model_shape: <svg id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 790 742"><defs></defs><ellipse className="cls-1 cls-wt" cx="487.67" cy="67.63" rx="116.11" ry="65.67"/><ellipse className="cls-1 cls-wt" cx="671.83" cy="297.86" rx="116.39" ry="65.67"/><ellipse className="cls-1 cls-wt" cx="487.61" cy="422.97" rx="116.39" ry="65.67"/><ellipse className="cls-1 cls-wt" cx="297.72" cy="552.75" rx="116.39" ry="65.67"/><ellipse className="cls-1 cls-wt" cx="118.94" cy="673.67" rx="116.39" ry="65.67"/></svg>,
    description: "W oczyszczalni znajduje się 5 osadników wtórnych. Zadaniem ich jest oddzielanie osadu czynnego od ścieków, oraz jego klarowanie i zagęszczanie. Część uzyskanego w ten sposób osadu wraca do komory beztlenowej, a jego nadmiar jest odprowadzany i trafia do komór fermentacyjnych.",
    descriptionEn: "There are 5 secondary settling tanks in the sewage treatment plant. Their tasks is to separate active sediment from sewage, as well as to clarify and concentrate sewage. Portion of active sediment acquired in this way returns to the anaerobic chamber and it's surplus is moved to the fermentation chambers.",
    images: [oswt1, oswt2, oswt3, oswt4],
    videos: [oswtVideo],
    audio: oswtaud,
    audioen: oswtauden,
    dur: 17707,
    spinBr: [
      {
        spin: [ooo, ooo2, ooo3, ooo4, ooo5],
        classSpin: ["spwt1", "spwt2", "spwt3", "spwt4", "spwt5"]
      }
    ] 
    
  },
  {
    id: 10,
    class: "koryto_wylotowe",
    title: "KORYTO WYLOTOWE",
    titleEn: "OUTLET TROUGH",
    model: koryto_wylotowe,
    model_shape: <svg id="Warstwa_1" className="W10" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199.83 130.26"><defs></defs><path className="cls-1" d="M1.17,20.76v8.39L0,29.65V44.82l172.28,85.44,27.55-22V92.36l-1.66-1.6V84.43L27.46,0Z"/></svg>, 
    description: "Oczyszczone ścieki odprowadzane są korytem wylotowym do rzeki Nacyny.",
    descriptionEn: "Treated sewage is moved to the Nacyna River through the outlet through.",
    images: [korWy1, korWy2, korWy3],
    videos: [korwyVideo],
    audio: korsaud,
    audioen: korsauden,
    dur: 4495,
    osadop: "osadop"
  },
  {
    id: 11,
    class: "stacja_pix",
    title: "STACJA PIX",
    titleEn: "PIX STATION",
    model: stacja_pix, 
    model_shape: <svg id="Warstwa_1" className="W11" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168.25 134.15"><defs></defs><path className="cls-1" d="M156.58,50.79s3.42-10-4.66-20.33S130,21.71,128.58,22.29s-12.91,9.83-12.91,9.83l-4.84-3.75s1.92-15.25-7.91-22.75S83.33.29,83.33.29a21,21,0,0,0-5.08,2.92C77.32,4,66.36,12.66,53.82,22.6a7,7,0,0,0-.8-.06,5.68,5.68,0,0,0-5.66,5.19L15,53.37A20.42,20.42,0,0,0,7.83,63.83a20.14,20.14,0,0,0-.16,10.34L0,80.6V91.93l84.75,42.22,83.5-66v-11Z"/></svg>,
    description: "Stacja dozowania to dwie cysterny o pojemności 28m<sup>3</sup> każda. Magazynowane są w nich substancje chemiczne, których dozowanie wspomaga usuwanie ze ścieków związków fosforu i poprawia jakość osadu czynnego. ",
    descriptionEn: "Each dosing station consists of two tanks with capacity of 28m<sup>3</sup> each. In them are stored chemical substances, which are dosed in order to support the removal of phosphorus compounds from sewage and improve the quality of active sediment.",
    images: [pix1, pix2, pix3, pix4],
    videos: [pixVideo],
    audio: pixaud,
    audioen: pixauden,
    dur: 14898,
    osadop: "osadop"
  },
  {
    id: 12,
    class: "wkf2",
    title: "WKFZ",
    titleEn: "CLOSED FERMENTATION CHAMBERS",
    model: wkf2, 
    model_shape: <svg id="Warstwa_1" className="W12" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 367.33 418.63"><defs></defs><path className="cls-1" d="M367.33,211.07c0-25.13-31.52-46.13-73.61-51.28-7-3.48-18.78-5.6-18.78-5.6-1.08-5.25-4.25-4.41-4.25-4.41l-7.5-13.5v-44h-1.27V136.5l-7,6.51-68.18-33.83c-6.69-20.85-35.59-37.41-72.57-41.81-7-3.39-18.49-5.45-18.49-5.45-1.08-5.25-4.25-4.42-4.25-4.42L83.94,44V0H82.67V44.22L53.37,71.53C22.29,80,.89,97.84.89,118.44H0V274.67H0a30.71,30.71,0,0,0,2.69,11.39v7.09a1.68,1.68,0,0,0,1.68,1.68H5.49a1.68,1.68,0,0,0,1.64-1.31c12.6,16.89,40.71,29.31,74.48,31.8v31.51l31.83,16.75v1.92l7.42,3.5,1.92-1.25,8.91,4.17,47.42-33.12v18.76h0a30.67,30.67,0,0,0,2.67,11.33v6.3a1.69,1.69,0,0,0,1.68,1.69h1.08a1.68,1.68,0,0,0,1.42-.8c14,19.11,47.77,32.59,87.23,32.59,51.31,0,93-22.79,94.09-51.11h0V211.33h0Z"/></svg>,
    description: "Dwa najwyższe zbiorniki na Oczyszczalni o pojemności 2 500 m<sup>3</sup> każdy to komory fermentacji zamkniętej - WKFZy. Trafiają tutaj tłuszcze, osady z osadników wstępnych oraz oasad nadmierny z osadników wtórnych. W wyniku procesu fermentacji, w temperaturze ok 36<sup>o</sup>C powstaje biogaz, którego głównym składnikiem jest metan.",
    descriptionEn: "The two highest tanks on the Sewage Treatment Plant with capacity of 2,500 m<sup>3</sup> each are the closed fermentation chambers. Fats, sediment from secondary aettling tanks are moved here. A biogas is created as a result of fermentation process in a temperature of approx. 36<sup>o</sup>C, the main component of which is methane.",
    images: [wkfz1, wkfz2, wkfz3, wkfz4],
    videos: [wkfzVideo],
    audio: wkfzaud,
    audioen: wkfzauden,
    dur: 24942,
    oczop: "oczop"

  },
  {
    id: 13,
    class: "prasa_tasmowa",
    title: "PRASA TAŚMOWA",
    titleEn: "BELT PRESS",
    model: prasa_tasmowa, 
    model_shape: <svg id="Warstwa_1" className="W13" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 201 175.58"><defs></defs><polygon className="cls-1" points="0 95.89 132.89 0 167 10.89 201 34.67 199.72 36.06 199.83 81 69.08 175.58 0 140.67 0 95.89"/></svg>,
    description: "Po zakończeniu procesu fermentacji osad z komór fermentacyjnych jest odwadniany na prasie taśmowej.",
    descriptionEn: "After the fermentation process is done, the sediment from fermentation chambers is dehydrated on the belt press.",
    images: [prasa1, prasa2, prasa3, prasa4, prasa5, prasa6],
    videos: [prasVideo],
    audio: prasaud,
    audioen: prasauden,
    dur: 6150,
    oczop: "oczop"

  },
  {
    id: 14,
    class: "zageszczacz_grawitacyjny",
    title: "ZAGĘSZCZACZ GRAWITACYJNY",
    titleEn: "GRAVITATIONAL THICKENER",
    model: zageszczacz_grawitacyjny,
    model_shape: <svg id="Warstwa_1" className="W14" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.56 136.56"><defs></defs><path className="cls-1" d="M98.93,17.8h0V10.13L96.29,8.58,92.5,11.67,83.71,7.58c0-2,0-4.08,0-6.12L81.22,0,65.1,11.67c-31.5.07-57,14.44-57,32.16v9.08L0,58.78V70.67l8.11,4.09V94.67c0,13.34,14.46,24.79,35.05,29.66l8.06,12.23,2.9-2.81-2-3.21,4.84-3.46L60,129.67l2.13-1.46v-1.43c1,0,2.1,0,3.16,0,31.61,0,57.23-14.4,57.23-32.16V43.83C122.56,33.13,113.24,23.65,98.93,17.8Z"/></svg>, 
    description: "Zagęszczacz grawitacyjny to niewielki zbiornik o pojemności 450 m<sup>3</sup>. Jego funkcja polega na grawitacyjnym zagęszczaniu osadu pochodzącego z osadników wstępnych przed wprowadzeniem do komór fermentacyjnych.",
    descriptionEn: "The gravitational thickener is a small tank with capacity of 450m<sup>3</sup>. It's function is to concentrate the sediment originating from inital settling tanks using gravitational method before the sediment is moved to the fermentation chambers.",
    images: [zag1, zag2, zag3, zag4, zag5],
    videos: [zagVideo],
    audio: zagaud, 
    audioen: zagauden, 
    dur: 14862,
    oczop: "oczop"
  },
  {
    id: 15,
    class: "biogaz",
    class2: "bio2",
    title: "ZBIORNIK MAGAZYNOWY BIOGAZU",
    titleEn: "BIOGAS STORAGE TANK",
    model: biogaz,
    model_shape: <svg id="Warstwa_1" className='W15' data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 416 291.52"><defs></defs><path className="cls-1" d="M387.33,110.86l-1.66,1.08V93.86l4.42-2.5V59.61L392.78,57l-8.24-2.83L371.44,65v52.67l2.92,1.62-1.36.88,10.83,6.33-56,42L304,155.86c1.43-7.13,11.82-64.17-28.38-111.16C230.66-7.87,163.44.11,158,.86c-52.74,7.2-82,44.19-87,50.66-36.67,47.88-26,102.1-24.33,110L0,195.52l187.67,96L416,124.86Zm-12-9,6.07-4.34v17.19l-6.07,4Z"/></svg>, 
    description: "Zbiornik magazynowy biogazu ma formę elastycznego balonu o pojemości 500 m<sup>3</sup>. Gromadzony jest w nim biogaz powstający w komorach fermentacyjnych podczas procesu fermentacji osadów.",
    descriptionEn: "The biogas storage tank has a form of flexible balloon with capacity of 5000m<sup>3</sup>. Inside of it is collected the biogas created in the fermentation chambers during the sediment fermentation process.",
    images: [bio1, bio2, bio3, bio4, bio5],
    videos: [gazVideo],
    audio: bioaud,
    audioen: bioauden,
    dur: 13392,
    oczop: "oczop"
  },
  {
    id: 16,
    class: "odsiarczalnik",
    title: "ODSIARCZALNIK",
    titleEn: "DESULPHURISATION MACHINE",
    model: odsiarczalnik,
    model_shape: <svg id="Warstwa_1" className="W16" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 164.58 115.83"><defs></defs><path className="cls-1" d="M140.11,52.1V25.44c0-14-19.9-25.44-44.44-25.44C75.83,0,59,7.44,53.31,17.72a7.89,7.89,0,0,0-5.87-1.19,9.62,9.62,0,0,0-5.82-4.78c2.05-2.5-1.12-3.54-1.12-3.54L26,3.88c-3.5.5-1.5,2.62-1.5,2.62L36,11l.17,3.27a12.45,12.45,0,0,1-2.17.1c-1.75,0-3.25,1.75-4.75,3.92a12,12,0,0,0-1.58,5.58,15.1,15.1,0,0,0-3,2.78,13,13,0,0,0-2.11,3.45A11.77,11.77,0,0,0,22,36.77L22,37c-2.05-1.12-6.66-3.25-10.64-1.42a7.43,7.43,0,0,0-.78.42l-.43.58C4.54,36.59,0,40.41,0,45.12s4.55,8.55,10.17,8.55c5.38,0,9.78-3.52,10.13-8l25.46,13L27.58,71.67c0,2.33-.11,4.66-.16,7l75,37.16L164.58,70V64.33Z"/></svg>,
    description: "Odsiarczalnik to miejsce, gdzie z biogazu usuwa się siarkę, aby uniknąć jej korozyjnego działania na pozostałe urządzenia.",
    descriptionEn: "The desulphurisation machine is a place, in which sulphur is removed from biogas in order to avoid its corrosive action on other devices.",
    images: [od1, od2, od3, od4, od5],
    videos: [odsVideo],
    audio: odsaud,
    audioen: odsauden,
    dur: 7916,
    oczop: "oczop"
  },
  {
    id: 17,
    class: "kotly2",
    title: "KOGENERATOR",
    titleEn: "CO-GENERATOR",
    model: kotly2 ,
    model_kotly: kotly,
    model_shape: <svg id="Warstwa_1" className="W17" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 155.09 172.85"><defs></defs><path className="cls-1" d="M149.92,46.86V41.27L70.59,0,0,50.33,82.16,94.9V90.25a3.65,3.65,0,0,1,7.29,0v82.6l56.18-40.16,3.5,1.92,1.46-1.25v-70l2.33-2.84V53.86l2.17-1.59v-2Z"/></svg>,
    description: "W kogeneratorze biogaz ulega przetworzeniu na energię elektryczną, która zasila obiekty Oczyszczalni. Jej nadmiar wprowadzany jest do ogólnej sieci energetycznej.",  
    descriptionEn: "In the co-generator, the biogas is converted into electrical energy that powers buildings of the Sewage Treatment Plant. Its surplus is introduced to the general grid. ",
    images: [kog1, kog2, kog3, kog4, kog5, kog6],
    videos: [kogVideo],
    audio: kogaud,
    audioen: kogauden,
    dur: 10470,
    oczop: "oczop"
  },
  {
    id: 18,
    class: "kotly",
    title: "KOTŁY",
    titleEn: "BOILER ROOM",
    model: kotly1,
    model_kotly: kotly,
    model_shape: <svg id="Warstwa_1" className="W18" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 147.53 171.38"><defs></defs><path className="cls-1" d="M143.88,37.24a3.64,3.64,0,0,0-3.64,3.64v4.65L58.08,1,.42,42.07,0,43.4v87.36l80.11,40.62,8.67-6.23h2.28l2.27-.72,12.17-9.15H107l.75-1.13-.54-1.87,40.28-28.8V40.88A3.64,3.64,0,0,0,143.88,37.24Z"/></svg>, 
    description: "W kotłowni spalana jest część wytworzonego biogazu. Uzyskaną energię cieplną wykorzystuje się do podgrzewania komór fermentacyjnych oraz ogrzewania budynku administracyjnego i wody użytkowej.",
    descriptionEn: "A part of the produced biogas is burned in the boiler room. The obtained heat energy is used to heat the fermentation chambers and to heat the administration building and drinking water. ",
    images: [kot1, kot2, kot3, kot4, kot5, kot6],
    videos: [kotlyVideo],
    audio: kotaud,
    audioen: kotauden,
    dur: 12420,
    oczop: "oczop"
  },
  {
    id: 19,
    class: "biokonwersja_odpadu",
    title: "INSTALACJA BIOKONWERSJI OSADU",
    titleEn: "SEDIMENT BIOCONVERSION PLANT",
     model: biokonwersja_odpadu,
     model_shape: <svg id="Warstwa_1" className="W19" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 398.33 325"><defs></defs><path className="cls-1" d="M.83,231.33v53.5L82,325,396,96.33V46.5l2.33-2.33V41L350.5,3.33,312,0,234.17,56.33c.33,1.43.66,2.86,1,4.28H236c0,1.76.07,3.52.11,5.28,0,1.61-.07,3.22-.11,4.83l-6.25-.89-139.47,102L77,170.83,0,226.75v4.83Z"/></svg>, 
    description: "W instalacji biokonwersji, z części odwodnionego osadu, wytwarza się paliwo, którego przeznaczeniem jest spalanie w elektrowniach i elektrociepłowniach.",
    descriptionEn: "In the bioconversion plant, a portion of dehydrated sediment is used to create fuel that will be burned in power stations and CHP plants.",
    images: [biokon1, biokon2, biokon3, biokon4],
    videos: [osadVideo],
    audio: biokonaud,
    audioen: biokonauden,
    dur: 9354,
    oczop: "oczop"

  },
  {
    id: 20,
    class: "biostruktury",
    title: "BIOSTRUKTURY",
    titleEn: "BIOSTRUCTURES",
     model: biostruktury, 
     model_shape: <svg id="Warstwa_1" className="W20" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 282.22 199.33"><defs></defs><polygon className="cls-1" points="0 94.22 0 114.89 172.44 199.33 282.22 113.11 282.22 93.11 280.22 93.11 280.22 84.22 109.11 0 2.89 85.56 2.89 92.51 0 94.22"/></svg>,
    description: "Zbiornik pełniących rolę &quot;oczka wodnego&quot;, zasilany ściekami oczyszczonymi przez naszą Oczyszczalnię. Doskonale rozwijają się tutaj różne gatunki flory i fauny wodnej, co dowodzi, że opuszczające Oczyszczalnię ścieki są bezpieczne dla środowiska.",
    descriptionEn: "A tank that acts as &quot;pond&quot; and is powered by sewage treated by our Sewage Treatment Plant. Various species of water fauna and flora thrive in it, which confirms that sewage leaving the Sewage Treatment Plant are safe for the environment. " ,
    images: [bios1, bios2, bios3, bios4, bios5, bios6, bios7],
    videos: [biostrVideo],
    audio: biostraud,
    audioen: biostrauden,
    dur: 15077,
    osadop: "osadop"
  },
  {
    id: 21,
    class: "pochodnia",
    class2: "pocho",
    title: "POCHODNIA",
    titleEn: "TORCH",
    model: pochodnia, 
    model_shape: <svg id="Warstwa_1" className="W21" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54.39 236.28"><defs></defs><path className="cls-1" d="M43.74,213V145.3c5.44-2.16,9-5.88,9-10.11,0-2.81-1.61-5.39-4.28-7.45V112.65c2.67-2.06,4.28-4.64,4.28-7.46s-1.61-5.39-4.28-7.45V82.65c2.67-2.06,4.28-4.64,4.28-7.46,0-6.69-9-12.11-20.13-12.11-1.07,0-2.12.06-3.15.16v-7l8.94-6.68L34.5,47.17,38.06,7.56,26.72,0,15.44,7.94l4.34,38.67-5,3.89,8.67,5.12v8.79c-6.51,2-11,6.08-11,10.78,0,4,3.24,7.55,8.22,9.76v2.81a8.83,8.83,0,0,0-3.5,7,8.5,8.5,0,0,0,.36,2.43c-3.15,2.14-5.08,5-5.08,8,0,4,3.24,7.55,8.22,9.76v10.49c-5,2.21-8.22,5.75-8.22,9.75s3.24,7.55,8.22,9.76v59.62L0,219.67l29.06,16.61,25.33-17.89Z"/></svg>,
    description: "Nadmiar wytworzonego biogazu jest spalany w pochodni.",
    descriptionEn: "A surplus of produced biogas is burned in the torch.",
    images: [pocho1, pocho2, pocho3],
    videos: [pochoVideo],
    audio: pochoaud,
    audioen: pochoauden,
    dur: 3527,
    flames: flames,
    oczop: "oczop"
  },
 
]




export default objects;




































// <img className="kraty" src={kraty} alt="" />
//             <img className="stacja_zlewna" src={stacja_zlewna} alt="" />
//             <img className="pompownia_glowna" src={pompownia_glowna} alt="" />

//             <img className="stacja_pix" src={stacja_pix} alt="" />
//             <img className="komora_beztlenowa" src={komora_beztlenowa} alt="" />

//             <img
//               id="scroller"
//               className="biokonwersja_odpadu"
//               src={biokonwersja_odpadu}
//               alt=""
//             />
//             <img className="biogaz" src={biogaz} alt="" />
//             <img className="kotly" src={kotly} alt="" />
//             <img className="odsiarczalnik" src={odsiarczalnik} alt="" />
//             <img
//               className="zageszczacz_grawitacyjny"
//               src={zageszczacz_grawitacyjny}
//               alt=""
//             />
//             <img className="wkf2" src={wkf2} alt="" />

//             <img className="koryto_pomiarowe" src={koryto_pomiarowe} alt="" />

//             <img className="piaskownik" src={piaskownik} alt="" />
//             <img className="piaskownik_schody" src={piaskownik_schody} alt="" />

//             
//             <img className="prasa_tasmowa" src={prasa_tasmowa} alt="" />

//             <img className="koryto_wylotowe" src={koryto_wylotowe} alt="" />
//             <img className="biostruktury" src={biostruktury} alt="" />

//             <img
//               className="komora_osadu_czynnego"
//               src={komora_osadu_czynnego}
//               alt=""
//             />
//             <img
//               className="komora_osadu_czynnego2"
//               src={komora_osadu_czynnego}
//               alt=""
//             />
//             <img
//               className="komora_osadu_czynnego3"
//               src={komora_osadu_czynnego}
//               alt=""
//             />
//             <img
//               className="komora_osadu_czynnego4"
//               src={komora_osadu_czynnego}
//               alt=""
//             />
//             <img className="komora_osadu_buda" src={komora_osadu_buda} alt="" />

//             <img className="pochodnia" src={pochodnia} alt="" />




